module.exports = __webpack_public_path__ + "img/air-icon.1a8a6c22.png";